/**
 * File Upload Port Handler
 * Handles file uploads to API via multipart/form-data
 */
const { getSelectedFile } = require("./file-selection.js");

const FileUploadPort = {
  add: function (app) {
    if (app.ports && app.ports.uploadFileToApi) {
      app.ports.uploadFileToApi.subscribe(async ({ request, url }) => {
        try {
          const file = getSelectedFile(request.fileIndex);
          if (!file) {
            throw new Error("File not found at index " + request.fileIndex);
          }

          const formData = new FormData();
          formData.append("file", file);

          const response = await fetch(url, {
            method: "POST",
            body: formData,
            headers: {
              Authorization: `Bearer ${request.authToken}`,
            },
          });

          if (response.ok) {
            const result = await response.json();
            if (app.ports.fileUploadResult) {
              app.ports.fileUploadResult.send({
                fileIndex: request.fileIndex,
                success: true,
                filePath: result.filePath,
                filename: result.filename,
              });
            }
          } else {
            const errorText = await response.text();
            throw new Error(`Upload failed with status: ${response.status} - ${errorText}`);
          }
        } catch (error) {
          console.error("FileUpload: Upload failed", error);

          if (app.ports.fileUploadResult) {
            app.ports.fileUploadResult.send({
              fileIndex: request.fileIndex,
              success: false,
              filePath: "",
              filename: "",
              error: error.message,
            });
          }
        }
      });
    }
  },
};

module.exports = FileUploadPort;
